import { createFileRoute } from '@tanstack/react-router';

import { MessageTrackerPage } from '@/features/message-log/components/MessageTrackerPage';

export const Route = createFileRoute('/admin/message-log')({
  component: MessageTrackerPage,
});
